import React, { useEffect }  from 'react';
import NextButton from '../nextButton';
import './style.css';

const Money = ({ onNextLevel, messNext, answer, setAnswer, img }) => {
	const ima = `images/money/${img}r_itog.jpg`;
	const ima_mob = `images/money/${img}r_mob.jpg`;
	// const srcset1 = `images/5000-p-500.jpeg 500w, images/5000-p-800.jpeg 800w, images/${ima}.jpg 911w`;
	// const srcset2 = `images/5000-p-500.jpeg 500w, images/5000-p-800.jpeg 800w, images/${ima_mob}.jpg 911w`;
	const imgRef = React.createRef();
	const maniRef = React.createRef();

	const tarelkaClasses = 'tarelka3 tarelka3-anistart';

	useEffect(()=>{
		// if(e.target.value ==='') {
			const itarelka = imgRef.current;
			const imani = maniRef.current;

			itarelka.classList.add('tarelka3-anistart');
			imani.classList.add('mani-anistart');

		setTimeout( ()=> {
		// const a = document.querySelector('img.tarelka3.tarelka3-anistart');
		// const itarelka = imgRef.current;
		// const imani = maniRef.current;
		itarelka.classList.remove('tarelka3-anistart');
		imani.classList.remove('mani-anistart');
	}, 800);
},[]);

	return ( 
		<div className="section">
			<div className="head">определи купюру</div>
			<div className="container">
				<div className="wrapper _3">
					<div className="head mobile">определи купюру</div>
					<div ref={maniRef} className="top-box _3 mani-anistart">
						<div className="img-mani-box">
							<img src={ima} loading="lazy" sizes="(max-width: 767px) 100vw, 685px"   alt="купюра" className="img-mani"/>
						</div>
						<div className="img-mani-box__mobile">
							<img src={ima_mob} loading="lazy" sizes="(max-width: 479px) 290px, (max-width: 767px) 300px, 100vw"  alt="купюра" className="img-mani"/>
						</div>
					</div>
					<div className="bottom-box">
						<div className="input-box">
							<div className="text-block">Впиши номинал купюры<span className="text-span"></span> в поле</div>
							<input autoFocus ref={input => input && input.focus()} value={answer} 
										onChange={(e)=> {
											setAnswer(e.target.value);
										} }
										className="input-q" />
						</div>
						<NextButton classes="button-q w-button" 
						onNextLevel={ answer!=='' ? onNextLevel: ()=>null} 
							messNext="Дальше" />
						</div>
							<img src="images/tarelka4.png" 
										ref={imgRef}
									 loading="lazy" alt="UFO" className={tarelkaClasses}/>
						</div>
			</div>
		</div>
  );
}

export default Money;
